import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			transform: "translate(0.867188 0.897217)",
			fill: "#ACAEB0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.5 9.39722C8.25736 9.39722 7.25 10.4046 7.25 11.6472V22.1472C7.25 23.3899 8.25736 24.3972 9.5 24.3972H24.5C25.7426 24.3972 26.75 23.3899 26.75 22.1472V11.6472C26.75 10.4046 25.7426 9.39722 24.5 9.39722H9.5ZM25.25 10.8972H8.74998V22.8972H25.25V10.8972Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.25,
			y: 13.1472,
			width: 19.5,
			height: 3,
			fill: "white"
		})
	]
});
export default SvgCardIcon;
